export var FlagNames = {
  JUMIO_COUNTDOWN: 'JUMIO_COUNTDOWN',
  JUMIO_POPUP_SHOW: 'JUMIO_POPUP_SHOW'
};

export var VerificationStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  REJECTED: 'REJECTED',
  REJECTED_WIP: 'REJECTED_WIP',
  REJECTED_MV: 'REJECTED_MV'
};

export var ACCOUNT_FLAGS_REQUESTED = 'ACCOUNT_FLAGS_REQUESTED';